import React, { useState } from "react";
import { TextField, Button, Typography, Alert } from "@mui/material";
import { requestPasswordReset } from "../api/authApi";
import getApiErrorMessage from "../utils/getApiErrorMessage";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [feedback, setFeedback] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await requestPasswordReset(email);
      setFeedback({ type: "success", message: res.message });
    } catch (err) {
      setFeedback({
        type: "error",
        message: getApiErrorMessage(err, "Something went wrong."),
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 400, margin: "auto", paddingTop: 300 }}>
      <Typography variant="h5" gutterBottom>
        Forgot Password
      </Typography>
      <TextField
        fullWidth
        label="Enter your email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        margin="normal"
      />
      <Button fullWidth variant="contained" type="submit">
        Send Reset Link
      </Button>
      {feedback && <Alert severity={feedback.type} sx={{ mt: 2 }}>{feedback.message}</Alert>}
    </form>
  );
}
